import { ajaxRequest } from "../../Utils/Ajax/ajax";
import { getTableLang } from "../../Utils/Inits/getTableLang";
import { alternativeList } from "../../Utils/Lists/alternativeList";
import { errorToast, successToast } from "../../Utils/utils";


export function loadAssignment(){

    const table = $("#students-table").DataTable({
        language: getTableLang(),
        dom: "<'row'<'col-sm-12 d-flex align-items-center justify-content-end'f>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-12'p>>",
        info: false,
        bLengthChange: false,
        paging: true,
        columnDefs: [
            {"orderable": false, "targets": [1]}
        ],
    })

    const students = new alternativeList("#students-table", ".student-row", "data-student", 'multi', table)

    $("#test-selection").on("change", function(){
        const newId = $(this).val().toString();
        const currentId = $("#test-id").val().toString()
        $("#test-id").val(newId)
        const currentUrl = $("#test-url").val().toString()
        $("#test-url").val(currentUrl.replace(currentId, newId))
    })

    $(".loadAb").on("click", function(){
        window.open($("#test-url").val().toString(), 'blank')
    });

    $(".create-assignment").on("click", function(){

        const courseId = Number($("#course-id").val())
        const assignmentId = Number($("#assignment-id").val())
        const testId = Number($("#test-selection").val())

        let url:string;
        if (assignmentId == 0){
            url = '/assignment/create/' + courseId.toString()
        } else {
            url = '/assignment/' + assignmentId.toString() + '/update'
        }

        const users = students.getIds();

        const success = function (data){
            window.location = data.redirect_url
        }

        const data = {
            users: users,
            test: testId,
            date: transformDate($("#due-date").val()),
            name: $("#assignment-name").val()
        }

        if (!check(data)){
            return;
        }

        ajaxRequest(url, success, data, $(this))
    })

    function transformDate(date){
        return date + ":00"
    }

    function check(data){
        let check = true;
        if (data.users == undefined || data.users.length == 0){
            check = false
            errorToast("Bitte wähle mindestens eine/-n Schüler/-in aus", "Fehler")
        }
        if (data.date == ''){
            check = false
            errorToast("Bitte lege ein finales Abgabedatum aus.", "Fehler")
        }
        return check
    }

}


